import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Label, Grid, Input, Form, Button } from "semantic-ui-react";
import { isEmpty } from "lodash";

import Layout from "../Common/Layout";
import AppButton from "../Common/AppButton";
import Loader from "../Common/Loader";

export const EditCustomerGroup = ({ customerGroup, updateField, touched, page }) => {
  return (
    <Grid.Row>
      <Grid.Column>
        <Form widths="equal">
          <Grid padded>
            {page === "Edit" && (
              <Grid.Row>
                <Grid.Column verticalAlign="middle" width={5}>
                  <label>Slug</label>
                </Grid.Column>
                <Grid.Column width={7} stretched textAlign="center">
                  <Input
                    disabled={true}
                    fluid
                    name="slug"
                    required
                    error={touched && isEmpty(customerGroup.slug)}
                    placeholder="Slug"
                    value={customerGroup.slug}
                    data-test="slug"
                  />
                </Grid.Column>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Column verticalAlign="middle" width={5}>
                <label>Name</label>
              </Grid.Column>
              <Grid.Column width={7} stretched textAlign="center">
                <Input
                  fluid
                  name="name"
                  required
                  error={touched && isEmpty(customerGroup.name)}
                  placeholder="Name"
                  value={customerGroup.name}
                  onChange={(e, data) => updateField({ name: data.value }, true)}
                  data-test="name"
                />
                {isEmpty(customerGroup.name) && touched && (
                  <Label basic color="red" pointing>
                    Name is required
                  </Label>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Grid.Column>
    </Grid.Row>
  );
};

class CustomerGroupForm extends PureComponent {
  state = {};

  static getDerivedStateFromProps(nextProps, state) {
    const { customerGroup } = nextProps;

    const nextState = {};

    if (!state.customerGroup && nextProps.page === "Edit") nextState.customerGroup = customerGroup;
    else if (!state.customerGroup && nextProps.page === "Create") nextState.customerGroup = { name: "" };

    return { ...state, ...nextState };
  }

  save = () => {
    const { customerGroup } = this.state;
    this.props.saveCustomerGroupChanges(customerGroup);
  };

  onUpdateField = (data, touched) => {
    const { customerGroup } = this.state;
    this.setState({ customerGroup: { ...customerGroup, ...data }, touched: touched });
  };

  render() {
    const { customerGroup, touched } = this.state;
    const { page } = this.props;

    return (
      <Layout.Page>
        <Layout.Header
          link={<AppButton icon="angle left" content="Back" as={Link} to="/customerGroups" size="large" />}
          title={`${page} customer group`}
        />
        {!isEmpty(customerGroup) ? (
          <Layout.Content>
            <Grid relaxed padded stackable>
              <EditCustomerGroup
                touched={touched}
                customerGroup={customerGroup}
                updateField={this.onUpdateField}
                page={page}
              />

              <Grid.Row>
                <Grid.Column>
                  <Button
                    data-test="updateCustomerGroupBtn"
                    color="orange"
                    disabled={isEmpty(customerGroup.name)}
                    onClick={this.save}
                    content={page === "Create" ? page : "Update"}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Layout.Content>
        ) : (
          <Loader message="Loading customer group..." />
        )}
      </Layout.Page>
    );
  }
}

export default CustomerGroupForm;
